<button nz-button nzType="link" nzShape="circle" nz-dropdown [nzDropdownMenu]="actions" nzTrigger="click" nzPlacement="topLeft" (click)="$event.stopPropagation()">
  <i nz-icon nzType="icons/fontawesome/solid:ellipsis-v"></i>
</button>
<nz-dropdown-menu #actions="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item  (click)="edit($event)" *ngIf="!isProductGroup">
      Rename
    </li>
    <li nz-menu-item (click)="delete($event)">
      Delete
    </li>
  </ul>
</nz-dropdown-menu>